import { ContentNodeUtils } from '../../ContentNode/ContentNode.utils';
import { createRuntimeOperationType } from './common';
export const referenceThisContentNodeOperationType = createRuntimeOperationType({
    kind: 'THIS_CONTENT_NODE_REFERENCE',
    dependencies: () => [],
    run: (selector, context) => {
        const THIS = context.THIS;
        if (!THIS) {
            throw new Error(`THIS not found`);
        }
        if (!selector?.length) {
            return THIS;
        }
        const foundContentNode = ContentNodeUtils.findContentNode(selector)(THIS);
        if (!foundContentNode) {
            return null;
        }
        return foundContentNode;
    },
});
//# sourceMappingURL=this-content-node-reference.js.map